<template>
  <HeadComponent />

  <div class="bg-white md:bg-red-100">
    <slot />
  </div>
</template>

<script>
import HeadComponent from './Components/Head.vue';

export default {
  components: {
    HeadComponent,
  },
};
</script>
